var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1984 12.401L24.4584 21.1114L25.0657 21.3954L25.8099 21.9634C25.8263 21.9789 25.8482 21.9943 25.8701 22.0047C26.264 22.2835 26.5212 22.7275 26.5212 23.2284C26.5212 24.0713 25.7778 24.7464 24.9125 24.7464H24.7539C24.7812 24.7464 24.8086 24.7464 24.8359 24.7412H5.01195C5.0393 24.7464 5.06668 24.7464 5.09404 24.7464H4.93534C4.11359 24.7464 3.33213 24.1136 3.33213 23.2284C3.33213 22.3867 4.04892 21.7052 4.93534 21.7052H5.50989L4.37725 16.0153C4.59609 14.0016 3.96687 11.8898 2.4895 10.4441C2.89988 9.90197 3.62762 9.40632 3.62762 9.40632L4.38817 9.9846L4.50856 10.0724C4.81497 10.3099 5.00647 10.6765 5.00647 11.0792C5.00647 11.3838 4.90251 11.6627 4.71649 11.8898L9.12668 15.4267L14.1059 6.39612C13.5478 6.12245 13.1593 5.55968 13.1593 4.91944C13.1593 4.00036 15.2386 3.02966 15.2386 3.02966L15.9061 3.54082L15.939 3.56149L16.1195 3.70088C16.4697 4.00553 16.6886 4.43922 16.6886 4.91944C16.6886 5.55968 16.3001 6.12245 15.7365 6.39612V6.40129L20.7267 15.4267L25.1314 11.8898C24.9453 11.6627 24.8359 11.3838 24.8359 11.0792C24.8359 10.3667 26.264 9.41145 26.264 9.41145L27.1231 10.062L27.145 10.0775C27.4459 10.3202 27.632 10.6816 27.632 11.0792C27.632 11.8072 27.0082 12.401 26.2367 12.401H26.1984Z",
    fill: "#F16522"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8791 14.7861L14.0785 4.28436V21.3963H16.8166L19.8791 14.7861Z",
    fill: "url(#paint0_linear_316_1626)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0795 4.28494L8.28373 14.7867L8.28369 14.7867L11.3415 21.3969H14.0795V4.28494Z",
    fill: "url(#paint1_linear_316_1626)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2405 18.3237L16.819 21.3968H14.0806V9.94849L18.2405 18.3237Z",
    fill: "url(#paint2_linear_316_1626)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0295 18.7799L16.819 21.3967H14.0806V11.3004L18.0295 18.7799Z",
    fill: "url(#paint3_linear_316_1626)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.91943 18.3263L14.0798 9.94852V21.3968H11.342L9.91943 18.3263Z",
    fill: "url(#paint4_linear_316_1626)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0774 11.3013V21.3963H11.3379L10.1293 18.78L14.0774 11.3013Z",
    fill: "url(#paint5_linear_316_1626)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6752 10.1344L19.8794 14.7861L16.8169 21.3962H20.3379L23.0065 14.7004L25.6752 10.1344Z",
    fill: "url(#paint6_linear_316_1626)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6752 10.1345L23.0066 14.7005L20.3379 21.3963H23.4287L25.6752 10.1345L25.6752 10.1345Z",
    fill: "url(#paint7_linear_316_1626)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0065 14.7004L18.241 18.328L18.2395 18.3257L16.8169 21.3963H20.3379L23.0065 14.7004Z",
    fill: "url(#paint8_linear_316_1626)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7459 15.3472L20.3367 21.396H16.8176L18.0304 18.7803L22.7459 15.3472Z",
    fill: "url(#paint9_linear_316_1626)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48279 10.1344L8.28331 14.7861L11.3411 21.3962H7.82008L5.15142 14.7004L2.48279 10.1344Z",
    fill: "url(#paint10_linear_316_1626)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48282 10.1345L5.15145 14.7005L7.82012 21.3963H4.72934L2.48279 10.1344L2.48282 10.1345Z",
    fill: "url(#paint11_linear_316_1626)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.151 14.7004L9.91651 18.328L9.91806 18.3257L11.3406 21.3963H7.81966L5.151 14.7004Z",
    fill: "url(#paint12_linear_316_1626)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41248 15.3475L7.8217 21.3963H11.3408L10.1281 18.7806L5.41248 15.3475Z",
    fill: "url(#paint13_linear_316_1626)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6745 22.5844C25.6745 23.4583 24.9088 24.1025 24.0659 24.1025H4.14057C3.25342 24.1025 2.53186 23.4216 2.53186 22.5844C2.53186 22.1659 2.7152 21.7864 3.005 21.5129C3.29479 21.2394 3.697 21.0664 4.14057 21.0664H24.0659C24.953 21.0664 25.6745 21.7473 25.6745 22.5844Z",
    fill: "url(#paint14_linear_316_1626)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6758 22.5853C25.6758 23.4235 24.9368 24.1045 24.0658 24.1045H23.9069C24.7546 24.1045 25.4904 23.4831 25.4904 22.6802C25.4904 21.8956 24.7807 21.4609 23.9069 21.4609H4.24831C3.37446 21.4609 2.66482 21.8956 2.66482 22.6802C2.66482 23.07 2.83956 23.4298 3.13087 23.6847C3.41684 23.9396 3.80873 24.1045 4.24831 24.1045C4.16364 24.0897 3.52453 24.1911 2.95609 23.6547C2.65952 23.3799 2.48474 23.0051 2.48474 22.5853C2.48474 21.7457 3.20498 21.0661 4.08943 21.0661H24.0658C24.9502 21.0661 25.6758 21.7457 25.6758 22.5853Z",
    fill: "#FFFD83"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0786 11.7213C14.2207 13.7958 14.2317 17.7774 14.0786 19.995C13.9257 17.7802 13.9364 13.7979 14.0786 11.7213Z",
    fill: "url(#paint15_radial_316_1626)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0791 5.75363C14.2212 6.82185 14.2321 8.87187 14.0791 10.0135C13.9262 8.87327 13.9368 6.82287 14.0791 5.75363Z",
    fill: "url(#paint16_radial_316_1626)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.338 21.3963C20.9891 20.1729 22.6359 16.0518 23.0067 14.7004C22.341 15.9489 20.7022 20.0725 20.338 21.3963Z",
    fill: "url(#paint17_radial_316_1626)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4237 10.5664C24.93 11.6614 23.9968 13.2663 23.2596 14.2691C23.7647 13.1468 24.7048 11.5458 25.4237 10.5664Z",
    fill: "url(#paint18_radial_316_1626)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80941 21.3777C7.15836 20.1544 5.51149 16.0333 5.14075 14.6819C5.54135 15.4333 7.4452 20.054 7.80941 21.3777Z",
    fill: "url(#paint19_radial_316_1626)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72412 10.5479C3.2178 11.6429 4.15107 13.2477 4.88818 14.2505C4.38313 13.1283 3.44303 11.5273 2.72412 10.5479Z",
    fill: "url(#paint20_radial_316_1626)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4274 21.395L25.2538 10.9995L19.5905 15.4085L14.0778 5.36397L8.57508 15.4085L2.90181 10.9995L4.72823 21.395L2.48145 10.1332L8.28315 14.7861L14.0778 4.28336L19.8796 14.7862L25.6742 10.1332L23.4274 21.395Z",
    fill: "#FEF328"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0768 5.94741C15.0507 5.94741 15.8403 5.20236 15.8403 4.28329C15.8403 3.36422 15.0507 2.61917 14.0768 2.61917C13.1028 2.61917 12.3132 3.36422 12.3132 4.28329C12.3132 5.20236 13.1028 5.94741 14.0768 5.94741Z",
    fill: "url(#paint21_linear_316_1626)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0772 5.75311C14.8738 5.75311 15.5196 5.14375 15.5196 4.39207C15.5196 3.64039 14.8738 3.03104 14.0772 3.03104C13.2806 3.03104 12.6349 3.64039 12.6349 4.39207C12.6349 5.14375 13.2806 5.75311 14.0772 5.75311Z",
    fill: "url(#paint22_linear_316_1626)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3932 11.7603C26.1656 11.7603 26.7918 11.1694 26.7918 10.4406C26.7918 9.71168 26.1656 9.12082 25.3932 9.12082C24.6208 9.12082 23.9946 9.71168 23.9946 10.4406C23.9946 11.1694 24.6208 11.7603 25.3932 11.7603Z",
    fill: "url(#paint23_linear_316_1626)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3931 11.606C26.0247 11.606 26.5367 11.1229 26.5367 10.5269C26.5367 9.93092 26.0247 9.44778 25.3931 9.44778C24.7615 9.44778 24.2495 9.93092 24.2495 10.5269C24.2495 11.1229 24.7615 11.606 25.3931 11.606Z",
    fill: "url(#paint24_linear_316_1626)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76734 11.7603C3.53975 11.7603 4.16591 11.1694 4.16591 10.4406C4.16591 9.71168 3.53975 9.12082 2.76734 9.12082C1.99493 9.12082 1.36877 9.71168 1.36877 10.4406C1.36877 11.1694 1.99493 11.7603 2.76734 11.7603Z",
    fill: "url(#paint25_linear_316_1626)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76712 11.606C3.3987 11.606 3.9107 11.1229 3.9107 10.5269C3.9107 9.93092 3.3987 9.44778 2.76712 9.44778C2.13554 9.44778 1.62354 9.93092 1.62354 10.5269C1.62354 11.1229 2.13554 11.606 2.76712 11.606Z",
    fill: "url(#paint26_linear_316_1626)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_1626",
    x1: 2.47772,
    y1: 12.8402,
    x2: 25.6701,
    y2: 12.8402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_316_1626",
    x1: 2.48805,
    y1: 12.8408,
    x2: 25.6809,
    y2: 12.8408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.136937,
    stopColor: "#ED971A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848648,
    stopColor: "#FEF328"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_316_1626",
    x1: 14.0807,
    y1: 15.6727,
    x2: 18.2408,
    y2: 15.6727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_316_1626",
    x1: 21.6601,
    y1: 16.3485,
    x2: 6.50023,
    y2: 16.3485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_316_1626",
    x1: 9.91977,
    y1: 15.6728,
    x2: 14.0799,
    y2: 15.6728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_316_1626",
    x1: 14.0779,
    y1: 16.3486,
    x2: 10.1295,
    y2: 16.3486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.120245,
    stopColor: "#FEE825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.330162,
    stopColor: "#FCCB1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604835,
    stopColor: "#FB9D13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.930612,
    stopColor: "#F85C04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942343,
    stopColor: "#F85A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_316_1626",
    x1: 2.48294,
    y1: 15.7651,
    x2: 25.6753,
    y2: 15.7651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.403604,
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942342,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_316_1626",
    x1: 8.06682,
    y1: 13.5326,
    x2: 24.6383,
    y2: 16.3139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699099,
    stopColor: "#F85A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950781,
    stopColor: "#FB9B19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_316_1626",
    x1: 16.8172,
    y1: 18.0484,
    x2: 23.0067,
    y2: 18.0484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_316_1626",
    x1: 16.8177,
    y1: 18.3718,
    x2: 22.7463,
    y2: 18.3718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20877,
    stopColor: "#FEE826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573088,
    stopColor: "#FDCB22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942342,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_316_1626",
    x1: 25.6756,
    y1: 15.7651,
    x2: 2.48271,
    y2: 15.7651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_316_1626",
    x1: 28.864,
    y1: 15.7652,
    x2: 2.48274,
    y2: 15.7652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F85A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_316_1626",
    x1: 23.9888,
    y1: 18.0484,
    x2: 5.15084,
    y2: 18.0484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_316_1626",
    x1: 11.3411,
    y1: 18.3721,
    x2: 5.41251,
    y2: 18.3721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20877,
    stopColor: "#FEE826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573088,
    stopColor: "#FDCB22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942342,
    stopColor: "#FCA81D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_316_1626",
    x1: 14.1037,
    y1: 21.0663,
    x2: 14.1037,
    y2: 24.1023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16522"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED971A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_316_1626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0789 15.875) scale(3.58173 2.92697)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_316_1626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0794 7.96446) scale(3.58176 1.50743)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_316_1626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6729 18.0483) scale(2.68003 2.52897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_316_1626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3421 12.4176) scale(1.58405 1.49477)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_316_1626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.47491 18.0296) rotate(180) scale(2.68004 2.52897)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_316_1626",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.80608 12.3993) rotate(180) scale(1.58406 1.49477)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1e-7,
    stopColor: "#FFFD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174803,
    stopColor: "#FFFD87",
    stopOpacity: 0.825
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355645,
    stopColor: "#FFFD94",
    stopOpacity: 0.644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539299,
    stopColor: "#FFFEA8",
    stopOpacity: 0.461
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724836,
    stopColor: "#FFFEC5",
    stopOpacity: 0.275
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910089,
    stopColor: "#FFFFEA",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_316_1626",
    x1: 12.3132,
    y1: 4.28329,
    x2: 15.8408,
    y2: 4.28329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_316_1626",
    x1: 14.0778,
    y1: 3.03104,
    x2: 14.0778,
    y2: 5.75363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_316_1626",
    x1: 23.9952,
    y1: 10.4406,
    x2: 26.7918,
    y2: 10.4406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_316_1626",
    x1: 25.3936,
    y1: 9.44778,
    x2: 25.3936,
    y2: 11.6065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_316_1626",
    x1: 1.36877,
    y1: 10.4406,
    x2: 4.16591,
    y2: 10.4406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_316_1626",
    x1: 2.76712,
    y1: 9.44778,
    x2: 2.76712,
    y2: 11.6065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886487,
    stopColor: "#FF7F02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown1);
export default __webpack_public_path__ + "static/media/crown 1.8751a3829d318cc52ed3c03392ded911.svg";
export { ForwardRef as ReactComponent };